import { WellFullDetailsDTO } from './well';

export type Wellbore = {
  ok: number;
  wellId: string;
  wellBoreId: string;
  wellName: string;
  wellBoreName: string;
  active: 0 | 1;
  field: string | null;
  country: string | null;
  operator: string | null;
  contacts: Contact[];
  tuwi: string | null;
  tuwbi: string | null;
  wellviewWellName: string | null;
  wellviewWellboreName: string | null;
  timezoneOffset: number | null;
  latitude: string | null;
  longitude: string | null;
  nocQatar: boolean | null;
  tdeskProjectUuid: string | null;
  tdeskWellboreUuid: string | null;
  locationType?: string;
  wellviewActive: boolean | null;
  spudDate: string | null;
  jobType: string | null;
  status: string | null;
  lastActivityDatetime?: string;
  tightWell: boolean;
};

export type WvWellbore = {
  tuwi: string;
  tuwbi: string;
  wellName: string;
  wellboreName: string;
  latitude: string;
  longitude: string;
  timezoneOffset: number;
};

export type Contact = {
  title: ContactTitle;
  name: string;
  email: string;
  phone: string;
};

export type InnerWellbore = {
  wellboreId?: string; // From Cosmos
  wellboreName?: string; // From Cosmos
  tuwbi?: string; // From Cosmos then map with wv
  wellviewWellboreName?: string; // From wvwellbore if null get the one in Cosmos
  lastActivityDatetime?: string; // From Cosmos raw-mnemonics
  contacts?: Contact[]; // From Cosmos
  tdeskProjectUuid?: string; // From Cosmos
  tdeskWellboreUuid?: string; // From Cosmos
  tightWellAccessible?: boolean;
};

export type InnerWellboreWithWellInfo = InnerWellbore & {
  well: WellFullDetailsDTO;
};

export type InnerSensorWellbore = InnerWellbore & {
  wellboreId: string;
};

export type InnerSensorWellboreWithWellInfo = InnerWellboreWithWellInfo & {
  well: { wellId: string };
  wellboreId: string;
};

export const isInnerSensorWellboreWithWellInfo = (
  wellbore?: InnerWellboreWithWellInfo,
): wellbore is InnerSensorWellboreWithWellInfo => !!(wellbore?.wellboreId && wellbore?.well.wellId);

export enum ContactTitle {
  DRILLING_COMPLETION_MANAGER = 'DRILLING_COMPLETION_MANAGER',
  DRILLING_COMPLETION_SUPERINTENDANT = 'DRILLING_COMPLETION_SUPERINTENDANT',
  LEAD_DRILLING_ENGINEER = 'LEAD_DRILLING_ENGINEER',
  LEAD_COMPLETION_ENGINEER = 'LEAD_COMPLETION_ENGINEER',
  FLUIDS_CEMENT_ENGINEER = 'FLUIDS_CEMENT_ENGINEER',
  BLOW_OUT_PREVENTION = 'BLOW_OUT_PREVENTION',
  FLUIDS_AND_CEMENTS = 'FLUIDS_AND_CEMENTS',
  DIRECTIONAL_DRILLING = 'DIRECTIONAL_DRILLING',
  PRODUCT_LINE_OPERATIONAL_ENGINEER = 'PRODUCT_LINE_OPERATIONAL_ENGINEER',
}

export const OPERATIONAL_CONTACTS = [
  ContactTitle.DRILLING_COMPLETION_MANAGER,
  ContactTitle.DRILLING_COMPLETION_SUPERINTENDANT,
  ContactTitle.LEAD_DRILLING_ENGINEER,
  ContactTitle.LEAD_COMPLETION_ENGINEER,
  ContactTitle.FLUIDS_CEMENT_ENGINEER,
];

export const HQ_CONTACTS = [
  ContactTitle.BLOW_OUT_PREVENTION,
  ContactTitle.FLUIDS_AND_CEMENTS,
  ContactTitle.DIRECTIONAL_DRILLING,
  ContactTitle.PRODUCT_LINE_OPERATIONAL_ENGINEER,
];

export const OFFSHORE_SUBSEA = 'Offshore Subsea';
export const OFFSHORE_SURFACE = 'Offshore Surface';
export const ONSHORE = 'Onshore';

export const isWellboreActiveSinceLastHour = (wellbore: InnerWellbore) => {
  const lastHour = new Date();
  lastHour.setHours(lastHour.getHours() - 1);
  if (wellbore.lastActivityDatetime === undefined) return false;

  return new Date(wellbore.lastActivityDatetime) > lastHour;
};
